import type { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { type CreateStrategyValues, createStrategySchema } from './CreateStrategyForm.schema'

type Submit = ReturnType<UseFormReturn<CreateStrategyValues>['handleSubmit']>
type Props = Omit<UseFormProps<CreateStrategyValues>, 'resolver'> & {
  strategyTypes: string[]
  onSubmit: SubmitHandler<CreateStrategyValues>
  children: (form: UseFormReturn<CreateStrategyValues>, submit: Submit) => React.ReactNode
}

export const CreateStrategyForm = ({ strategyTypes, onSubmit, children, ...options }: Props) => {
  const form = useFormWithSchema({ mode: 'all', ...options }, createStrategySchema(strategyTypes))
  const submit = form.handleSubmit(onSubmit)

  return (
    <Form {...form}>
      <form onSubmit={submit}>{children(form, submit)}</form>
    </Form>
  )
}
